<template>
	<div class="ui fluid container fc-myorders">
		<div class="fc-banner">
			<div class="ui container">
				<div class="fc-crumbs">
					<router-link :to="`${this.RouterConfig.Home}`">Home</router-link>
					&gt;
					<span>Account Profile</span>
				</div>
				<div class="fc-title" v-if="loginInfo != null && loginInfo != undefined">
					Hi, {{ loginInfo.FullName }}
				</div>
			</div>
		</div>
		<div class="ui container fc-content">
			<div>
				<left-nav />
			</div>
			<div class="fc-credit-info">
				<label>My Credit</label>
				<div>
					<div><span class="icon-ico-earn"></span></div>
					<div>
						<div>
							<label>CREDIT AVAILABLE:</label>
							<span>${{ myCredit.PointsBalance | price }}</span>
						</div>
						<div v-if="myCredit.PointsExpireDate != ''">
							<label>EXPIRY DATE:</label>
							<span>{{ myCredit.PointsExpireDate }}</span>
						</div>
						<div>
							<label>CREDIT USED:</label>
							<span>${{ myCredit.PointsUsed | price }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="fc-rewards-list">
				<label>Rewards Point History</label>
				<div class="fc-table">
					<div class="fc-item fc-header">
						<div>ORDER DATE</div>
						<div>ORDER NO.</div>
						<div>CREDIT</div>
						<div>Expiry Date</div>
					</div>
					<div class="fc-item" v-if="pointList.PointsLogs != null" v-for="credit in pointList.PointsLogs">
						<div>{{ credit.CreateDateTime | dateToString('dd/M/yyyy') }}</div>
						<div>{{ credit.OrderNo }}</div>
						<div v-if="credit.FPointType == 1">${{ credit.Point | price }}</div>
						<div v-if="credit.FPointType == 2" class="fc-minus">-${{ credit.Point | price }}</div>
						<div>{{ credit.ExpiryDate | dateToString('dd/M/yyyy') }}</div>
					</div>
				</div>
				<div class="fc-orders-pagination">
					<pagination :totalPage="pointList.TotalPage" :currPage="currPage" :param='"page"' />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import LeftNavigator from '../../components/profile/LeftNavigator'
import Pagination from '../../components/Pagination/Pagination'
export default {
  name: 'MyOrders',
  data () {
    return {
      currPage: 0,
      pointList: [],
      myCredit: {}
    }
  },
  components: {
    'left-nav': LeftNavigator,
    'pagination': Pagination
  },
  created () {
    const page = this.$route.query.page
    var curr = 1
    if (page === null || page === undefined || parseInt(page).isNaN) {
      curr = 1
    } else {
      curr = parseInt(page)
    }
    this.currPage = curr
    const data = {
      PageNum: curr
    }
    this.$store.dispatch('customer/customerPointsPaging', data)
      .then(d => {
        this.pointList = d
      })
    this.$store.dispatch('customer/customerCredit', data)
      .then(d => {
        this.myCredit = d
      })
  },
  computed: {
    ...mapGetters('profileLogin', ['loginInfo'])
  }
}
</script>


// WEBPACK FOOTER //
// src/views/profile/Credit.vue